import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getCurrentUser } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { getFilterAllCandidates, loadCandidatesByFilter } from "../../app/store/candidate";
import { getFieldData } from "../../Services/appService";
import PDFObject from "pdfobject";

const Help = (props) => {

  const { helpShowHide, handleHelpShowHide, module, helpDocs } = props;
  const usrType = localStorage.getItem("userType");
  const [entityType, setEntityType] = useState(null);
  const [pdfViewUrl, setPdfViewUrl] = useState("");

  const filterAllCandidatesSelector = useSelector(getFilterAllCandidates)

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    const frmBody = new FormData();
    frmBody.append("id", currentUser.id);
    frmBody.append("name", "");
    frmBody.append("email", "");
    frmBody.append("entity", "");
    frmBody.append("type", "candidate");
    frmBody.append("filterType", "single");
    dispatch(loadCandidatesByFilter(frmBody))
  }, []);

  useEffect(() => {
    if (filterAllCandidatesSelector.length > 0) {
      const perfData = filterAllCandidatesSelector[0].performerData;
      const ent = getFieldData(perfData, "candidateonboardingform", "CandidateEntity");
      setEntityType(ent);
    }
  }, [filterAllCandidatesSelector]);

  useEffect(() => {
    let objectUrl = "";
    let isActive = true;

    if (module === "Support") return;

    const helpDocUrl =
      typeof helpDocs === "string" ? helpDocs : helpDocs?.uploadUrl;
    if (!helpDocUrl) {
      setPdfViewUrl("");
      return;
    }

    const loadPdfAsBlobUrl = async () => {
      try {
        const response = await fetch(helpDocUrl);
        if (!response.ok) throw new Error("Failed to fetch help document");

        const fileBlob = await response.blob();
        const pdfBlob =
          fileBlob.type === "application/pdf"
            ? fileBlob
            : new Blob([fileBlob], { type: "application/pdf" });

        objectUrl = URL.createObjectURL(pdfBlob);
        if (isActive) setPdfViewUrl(objectUrl);
      } catch (error) {
        if (isActive) setPdfViewUrl(helpDocUrl);
      }
    };

    loadPdfAsBlobUrl();

    return () => {
      isActive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [helpDocs, module]);

  useEffect(() => {
    if (module === "Support" || !pdfViewUrl) return;

    const options = {
      pdfOpenParams: {
        toolbar: "0", // Show the toolbar
        navpanes: "0", // Hide the left navigation pane
        scrollbars: "0", // Hide the scrollbar
        print: "false", // Disable the print button
        download: "false", // Disable the download button
      },
    };

    PDFObject.embed(pdfViewUrl, "#pdf-viewer", options);
    if (document.getElementById('pdf-viewer')) {
      document.getElementById('pdf-viewer').style.width = '77%';
      document.getElementById('pdf-viewer').style.margin = 'auto';
    }
  }, [pdfViewUrl, module]);

  return (
    <Modal show={helpShowHide} size="xl">
      <Modal.Header closeButton onHide={handleHelpShowHide}>
        <Modal.Title>
          {module === "Support" ? "Add Issue" : "Help"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="border">
        {module === "Support" ?
          (
            <div className="row border bg-white pt-3 pb-3 rounded">
              <div className="col-md-12 form-group">
                <h3>Welcome to our Customer Support Portal!</h3>
              </div>
              <div className="col-md-12 form-group">
                <p>In this portal we offer you an easy way to register any issue you may encounter while working and using
                  various functions and features.
                </p>
              </div>
              <div className="col-md-12 form-group">
                <p>Once you register an issue and submit, it will be received by our dedicated and committed customer and
                  technical support staff who will review and provide instant fix(s), if required.</p>
              </div>
              <div className="col-md-12 form-group">
                <p>Our customer and technical support staff will also update and notify you of the action taken.</p>
              </div>
              <div className="col-md-12 form-group">
                <h3>Thank you.</h3>
                <h3>WorkFINITY®</h3>
                <h3>
                  Customer and Technical Support</h3>
              </div>
            </div>
          ) : (
            <div id="pdf-viewer" style={{ height: "600px" }}></div>
          )
        }
      </Modal.Body>
      {/* <Modal.Footer>
        <button
          className="btn btn-sm btn-outline-default"
          onClick={handleHelpShowHide}
        >
          <i class="fa fa-times mr-1" aria-hidden="true"></i> Close
        </button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default Help;
